<template>
    <li class="p-1 ml-4 d-flex flex-align-center" :title="disk.path" data-collapsed="true">
      <span class="d-flex flex-align-center">
        <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5 7h14a3 3 0 0 1 2.995 2.824L22 10v4a3 3 0 0 1-2.824 2.995L19 17H5a3 3 0 0 1-2.995-2.824L2 14v-4a3 3 0 0 1 2.824-2.995L5 7h14H5Zm13 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" fill="#212121"/></svg>
      </span>
      <!--input class="ml-5" type="checkbox" v-model="disk.selected"-->      
      <span class="ml-3">{{ disk.name }} [{{ disk.size_string }}]</span>
    </li>
  </template>
  
  <script>
  export default {
    name:"TreeDisk",
    props: {
      disk: Object,
    },
  };
  </script>
  
  <style scoped>
  .ml-5 {
    margin-left: 5px;
  }
  </style>
  